import { t } from '@lingui/macro';

export default ({ i18n }) => ({
  HIGHEST_ATTEMPT_TEXT: i18n._(t('AssignmentFilters.highestAttempts')`Showing highest attempts`),
  ASSIGNED_ATTEMPT_TEXT: i18n._(t('AssignmentFilters.assignedAttempts')`Showing assigned attempts`),
  VOLUNTARY_ATTEMPT_TEXT: i18n._(t('AssignmentFilters.voluntaryAttempts')`Showing voluntary attempts`),
  FILTER_ATTEMPTS_HEADING_TEXT: i18n._(t('FilterOptions.filterStudentAttemps')`Filter student attempts by`),
  FILTER_ALL_HIGHEST_TEXT: i18n._(t('FilterOptions.highestAttempt')`All highest`),
  FILTER_TEACHER_ASSIGNED_TEXT: i18n._(t('FilterOptions.latestAssigned')`Teacher assigned`),
  FILTER_VOLUNTARY_ATTEMPT_TEXT: i18n._(t('FilterOptions.voluntaryAttempt')`Voluntary attempt`),
  FILTER_INFO_HIGHEST_TEXT: i18n.t`FilterInfo.Highest`,
  FILTER_INFO_LATEST_TEXT: i18n.t`FilterInfo.Latest`,
  FILTER_INFO_VOLUNTARY_TEXT: i18n.t`FilterInfo.Voluntary`,
  FILTER_LABEL_HOVER_TEXT: i18n.t`Filter student attempts by scenario`
});
